<ion-row [ngClass]="['align-items-center border-b flex-nowrap pb-8', classDiv]">
  <ps-icon
    iconClass="mr-8"
    [iconColor]="iconColor"
    [iconSize]="iconSize"
    [srcIcon]="srcIcon"></ps-icon>
  <ion-label class="f13">{{ info }}</ion-label>
</ion-row>
